export default __webpack_public_path__ + "static/media/resources.cd0a6d1e.jpg";